import { useEffect, useMemo, useState } from "react";
import { FormService } from "../../../services/FormsService";
import CustomDataTable from "../../../components/CustomDataTable";
import { DateUtil } from "../../../utils/date";
import { AlertService } from "../../../services/Alert";
import FormModal from "./FormModal";
import Button from "../../../components/form-controls/Button";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { useTranslation } from "react-i18next";
import useRequest from "../../../hooks/useRequest";
function FormsPartial() {

    const { t }= useTranslation();
    const {call, isRequesting:isLoading} = useRequest();
    const { account } = useCurrentAccount();

    const [forms, setForms] = useState([])
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState(null)
    const [isRequesting, setIsRequesting] = useState(false)

    const columns = useMemo(() => [
        {
            name: t("config.forms.name"),
            sortable: true,
            selector: row => row.name,
        },
        {
            name: t("config.forms.last-update"),
            sortable: true,
            selector: row => <p className="text-nowrap mb-0">{DateUtil.format(row.date)}</p>,
        },
        {
            name: t("config.forms.status"),
            sortable: true,
            cell: (row) => {
                return (
                    row.status === 0 ?
                        (
                            <span className="badge bg-soft-danger text-danger">
                                <span className="legend-indicator bg-danger"></span> {t("config.forms.inactive")}
                            </span>
                            
                        ) :
                        (
                            <span className="badge bg-soft-info text-info">
                                <span className="legend-indicator bg-info"></span> {t("config.forms.active")}
                            </span>
                        )
                )
            }
        },

        {
            name: t("config.forms.actions"),
            sortable: false,
            center: true,
            cell: (row) => {
                return (
                    <div className="btn-group" role="group">
                        {/* <button className="btn btn-white btn-sm" onClick={() => editForm(row.id)}>
                            
                        </button> */}

                        <Button className="btn btn-white btn-sm" isLoading={isRequesting} onClick={() => editForm(row.id)}>
                            {t("config.forms.edit-text")}
                        </Button>

                        <div className="btn-group">
                            <button type="button" className="btn btn-white btn-icon btn-sm dropdown-toggle dropdown-toggle-empty" data-bs-toggle="dropdown" aria-expanded="false"></button>

                            <div className="dropdown-menu dropdown-menu-end mt-1" >
                                <button className="dropdown-item"  onClick={ () => changeStatus(row.id, row.status)}>
                                    { row.status === 0 ? 'Activar': t("config.forms.disabled") }
                                </button>
                                <button className="dropdown-item"  onClick={ () => deleteForm(row.id)}>
                                    {t("config.forms.delete")}
                                </button>
                            </div>
                        </div>

                    </div>
                )
            }
        },
    ], []);

    const changeStatus = async (id, status) => {
        const isConfirmed = await AlertService.warning('Aviso', '¿Estás seguro de querer cambiar el estatus del formulario?', async () => {
            try {
                await FormService.changeStatus(id, status? 0: 1);
                await getForms()
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', 'Ocurrió un error al cambiar el estatus del formulario, intenta nuevamente')
            }
        });

        if (isConfirmed) {
            AlertService.success('¡Éxito!', "Se cambio correctamente el estatus del formulario");
        }
    }

    const deleteForm = async(id) => {
        const isConfirmed = await AlertService.warning('Borrar formulario', '¿Estás seguro de querer borrar este formulario? Esta acción no se puede deshacer', async () => {
            try {
                await FormService.delete(id)
                await getForms()
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', 'Ocurrió un error al borrar el formulario, intenta nuevamente')
            }
        });

        if (isConfirmed) {
            AlertService.success('¡Éxito!', 'Se borró el formulario correctamente');
        }
    }

    const editForm = async(formId) => {
        setIsRequesting(true)
        const { data } = await FormService.getForm(formId);
        
        let form = data;
        form.categories = form.categories.split(',')
        
        form.keys = form.keys.map( k => {
            k.options = k.options ? k.options.split(','): []

            if(k.type === 'date') {
                k.dateConfig = {
                    isLimited: k.options.length ? true: false,
                    min: k.options.length ? k.options[0]: 1,
                    max: k.options.length ? k.options[1]: 1
                }
            }
            return k
        })
        
        setIsRequesting(false)
        setFormData(form)
        setShowModal(true)
        
    }

    const getForms = async () => {
        const { data } = await call(() => FormService.getForms(account.id));
        setForms(data)
    }

    const handleCloseModal = async(reload) => {
        if(reload) {
            await getForms();
        }

        setShowModal(false)
        // setFormData(null)
    }

    useEffect(() => {
        if (account) {
            getForms()
        }
    }, [account])


    
    return (
        <>
            <div className="card">

                <div className="card-header d-flex align-items-center">
                    <div className="me-3">
                        <h2 className="card-title h4">{t("config.forms.form-title")}</h2>
                        <p className="small mb-0">
                            {t("config.forms.form-p")}
                        </p>
                    </div>

                    <div className="col-sm-auto">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => setShowModal(true)}
                        >
                            <i className="bi-plus-lg me-1"></i>
                                {t("config.forms.create-btn")}
                        </button>
                    </div>
                </div>

                <div className="card-body">
                    <CustomDataTable
                        columns={columns}
                        data={forms}
                        hideAccountsFilter
                        isLoading={isLoading}
                        filter={(row, term) => {
                            if (!term) return true;

                            return (
                                `${row.description}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.name}`.match(new RegExp(`${term}`, 'i'))
                            )
                        }}
                    />

                </div>
            </div>

            <FormModal 
                show={showModal}
                onRequestClose={ (reload) => handleCloseModal(reload) }
                data={formData}
            />
        </>
    )
}
export default FormsPartial